import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from './AbstractList.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.$this_1 = $outer;
        this.index_1 = 0;
        this.last_1 = -1;
      }
      hasNext_bitz1p_k$() {
        return this.index_1 < this.$this_1.get_size_woubt6_k$();
      }
      next_20eer_k$() {
        if (!this.hasNext_bitz1p_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.last_1 = _unary__edvuaz;
        return this.$this_1.get_c1px32_k$(this.last_1);
      }
      remove_ldkf9o_k$() {
        // Inline function 'kotlin.check' call
        if (!!(this.last_1 === -1)) {
          var message = 'Call next() or previous() before removing element from the iterator.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.$this_1.removeAt_6niowx_k$(this.last_1);
        this.index_1 = this.last_1;
        this.last_1 = -1;
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_2 = $outer;
        super($outer, $box);
        Companion_instance.checkPositionIndex_w4k0on_k$(index, this.$this_2.get_size_woubt6_k$());
        this.index_1 = index;
      }
      hasPrevious_qh0629_k$() {
        return this.index_1 > 0;
      }
      previous_l2dfd5_k$() {
        if (!this.hasPrevious_qh0629_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        this.index_1 = this.index_1 - 1 | 0;
        tmp.last_1 = this.index_1;
        return this.$this_2.get_c1px32_k$(this.last_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractMutableList() {
      constructor(list, fromIndex, toIndex) {
        return new.target.new_kotlin_collections_AbstractMutableList_SubList_kflm75_k$(list, fromIndex, toIndex);
      }
      static new_kotlin_collections_AbstractMutableList_SubList_kflm75_k$(list, fromIndex, toIndex) {
        var $this = this.new_kotlin_collections_AbstractMutableList_ddn594_k$();
        $this.list_1 = list;
        $this.fromIndex_1 = fromIndex;
        $this._size_1 = 0;
        Companion_instance.checkRangeIndexes_mmy49x_k$($this.fromIndex_1, toIndex, $this.list_1.get_size_woubt6_k$());
        $this._size_1 = toIndex - $this.fromIndex_1 | 0;
        return $this;
      }
      add_dl6gt3_k$(index, element) {
        Companion_instance.checkPositionIndex_w4k0on_k$(index, this._size_1);
        this.list_1.add_dl6gt3_k$(this.fromIndex_1 + index | 0, element);
        this._size_1 = this._size_1 + 1 | 0;
      }
      get_c1px32_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this._size_1);
        return this.list_1.get_c1px32_k$(this.fromIndex_1 + index | 0);
      }
      removeAt_6niowx_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this._size_1);
        var result = this.list_1.removeAt_6niowx_k$(this.fromIndex_1 + index | 0);
        this._size_1 = this._size_1 - 1 | 0;
        return result;
      }
      set_82063s_k$(index, element) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this._size_1);
        return this.list_1.set_82063s_k$(this.fromIndex_1 + index | 0, element);
      }
      removeRange_sm1kzt_k$(fromIndex, toIndex) {
        this.list_1.removeRange_sm1kzt_k$(this.fromIndex_1 + fromIndex | 0, this.fromIndex_1 + toIndex | 0);
        this._size_1 = this._size_1 - (toIndex - fromIndex | 0) | 0;
      }
      get_size_woubt6_k$() {
        return this._size_1;
      }
      checkIsMutable_jn1ih0_k$() {
        return this.list_1.checkIsMutable_jn1ih0_k$();
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var AbstractMutableListClass;
function AbstractMutableList() {
  if (AbstractMutableListClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static new_kotlin_collections_AbstractMutableList_ddn594_k$() {
        var $this = this.new_kotlin_collections_AbstractMutableCollection_jgoj1k_k$();
        $this.modCount_1 = 0;
        return $this;
      }
      add_utx5q5_k$(element) {
        this.checkIsMutable_jn1ih0_k$();
        this.add_dl6gt3_k$(this.get_size_woubt6_k$(), element);
        return true;
      }
      clear_j9egeb_k$() {
        this.checkIsMutable_jn1ih0_k$();
        this.removeRange_sm1kzt_k$(0, this.get_size_woubt6_k$());
      }
      iterator_jk1svi_k$() {
        return new (IteratorImpl())(this);
      }
      contains_aljjnj_k$(element) {
        return this.indexOf_si1fv9_k$(element) >= 0;
      }
      indexOf_si1fv9_k$(element) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            if (equals(item, element)) {
              tmp$ret$0 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$0 = -1;
        }
        return tmp$ret$0;
      }
      listIterator_70e65o_k$(index) {
        return new (ListIteratorImpl())(this, index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return SubList().new_kotlin_collections_AbstractMutableList_SubList_kflm75_k$(this, fromIndex, toIndex);
      }
      removeRange_sm1kzt_k$(fromIndex, toIndex) {
        var iterator = this.listIterator_70e65o_k$(fromIndex);
        // Inline function 'kotlin.repeat' call
        var times = toIndex - fromIndex | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            iterator.next_20eer_k$();
            iterator.remove_ldkf9o_k$();
          }
           while (inductionVariable < times);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.orderedEquals_u132tq_k$(this, other);
      }
      hashCode() {
        return Companion_instance.orderedHashCode_bw6kwp_k$(this);
      }
    }
    initMetadataForClass($, 'AbstractMutableList', VOID, VOID, [KtMutableList()]);
    AbstractMutableListClass = $;
  }
  return AbstractMutableListClass;
}
//region block: exports
export {
  AbstractMutableList as AbstractMutableList192xfq8ycgofs,
};
//endregion

//# sourceMappingURL=AbstractMutableListJs.mjs.map
